import { useState, useCallback, useEffect } from "react";
import { API } from "@/lib/api";

const KEY = "alphasync_watchlist";
const CODE_KEY = "alphasync_wl_code";

const read = () => {
  try { return new Set(JSON.parse(localStorage.getItem(KEY) || "[]")); } catch { return new Set(); }
};

const genCode = () => {
  let c = localStorage.getItem(CODE_KEY);
  if (!c) {
    c = Math.random().toString(36).slice(2, 8).toUpperCase();
    localStorage.setItem(CODE_KEY, c);
  }
  return c;
};

const persistRemote = (code, tickers) => {
  fetch(`${API}/watchlist/${code}`, {
    method: "PUT", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ tickers }),
  }).catch(() => {});
};

export function useWatchlist() {
  const [set, setSet] = useState(read);
  const [code] = useState(genCode);

  useEffect(() => {
    const onStorage = (e) => { if (e.key === KEY) setSet(read()); };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const write = useCallback((next) => {
    const arr = [...next];
    localStorage.setItem(KEY, JSON.stringify(arr));
    persistRemote(code, arr);
  }, [code]);

  const toggle = useCallback((ticker) => {
    setSet((prev) => {
      const next = new Set(prev);
      next.has(ticker) ? next.delete(ticker) : next.add(ticker);
      write(next);
      return next;
    });
  }, [write]);

  const adopt = useCallback(async (rawCode) => {
    const c = (rawCode || "").trim().toUpperCase();
    if (!c) return false;
    try {
      const res = await fetch(`${API}/watchlist/${c}`);
      const data = await res.json();
      const next = new Set(data.tickers || []);
      localStorage.setItem(CODE_KEY, c);
      localStorage.setItem(KEY, JSON.stringify([...next]));
      setSet(next);
      window.location.reload();
      return true;
    } catch { return false; }
  }, []);

  const has = useCallback((t) => set.has(t), [set]);
  return { watchlist: set, toggle, has, count: set.size, code, adopt };
}
